import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD7-d6E4nPTNNT2xhPFqBqJLm_M-dyjTmU",
  authDomain: "projeto-omni-291913.firebaseapp.com",
  databaseURL: "https://projeto-omni-291913.firebaseio.com",
  projectId: "projeto-omni-291913",
  storageBucket: "projeto-omni-291913.appspot.com",
  messagingSenderId: "765706788865",
  appId: "1:765706788865:web:ef64dad9b7b383cb842000",
  measurementId: "G-M3SBGERZEB"
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);



